'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by Administrator on 2016/8/2.
                                          */

//  ListPageFilterBar HomePageOrderBar


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _customProductListPage = require('redux/modules/customProductListPage');

var customProductListPageAction = _interopRequireWildcard(_customProductListPage);

var _productListPage = require('redux/modules/productListPage');

var _background = require('redux/modules/background');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomProductList = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store;
    var dispatch = _ref$store.dispatch;
    var getState = _ref$store.getState;
    var location = _ref.location;

    var promises = [];
    var query = location.query;
    var filter = '';
    var page = null;
    var orderItem = '';
    var direction = '';
    if (query.type) {
      filter = { type: query.type };
    }
    if (query.productType) {
      filter = (0, _extends3.default)({}, filter, { productType: query.productType });
      promises.push(dispatch((0, _productListPage.changeSelectedSecondItemId)(query.productType)));
    } else {
      promises.push(dispatch((0, _productListPage.changeSelectedSecondItemId)('')));
    }
    if (query.shop) {
      filter = (0, _extends3.default)({}, filter, { shopId: query.shop });
    }
    if (query.author) {
      filter = (0, _extends3.default)({}, filter, { authorId: query.author });
    }
    if (query.findValue) {
      filter = (0, _extends3.default)({}, filter, { FindValue: query.findValue });
    }
    if (query.isExperienceProduct) {
      filter = (0, _extends3.default)({}, filter, { isExperienceProduct: query.isExperienceProduct });
    }
    if (query.isExperienceGoods) {
      filter = (0, _extends3.default)({}, filter, { isExperienceGoods: query.isExperienceGoods });
    }
    if (query.isAppreciationGoods) {
      filter = (0, _extends3.default)({}, filter, { isAppreciationGoods: query.isAppreciationGoods });
    }
    if (query.isCommonProduct) {
      filter = (0, _extends3.default)({}, filter, { isCommonProduct: query.isCommonProduct });
    }
    if (query.page) {
      page = query.page;
    }
    if (query.orderItem) {
      orderItem = query.orderItem;
    }
    if (query.direction) {
      direction = query.direction;
    }
    promises.push(dispatch((0, _background.changeHeaderText)('艺品定制')));
    promises.push(dispatch(customProductListPageAction.load(filter, {
      orderItem: orderItem,
      direction: direction
    }, customProductListPageAction.isLoaded(getState()), page)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.customProductListPage.data,
    currentPage: state.customProductListPage.currentPage,
    filterData: state.customProductListPage.filterData,
    dataError: state.customProductListPage.error,
    selectedFirstItemId: state.productListPage.selectedFirstItemId,
    selectedSecondItemId: state.productListPage.selectedSecondItemId
  };
}, (0, _extends3.default)({}, customProductListPageAction, {
  onChangeSelectedFirstItemId: _productListPage.changeSelectedFirstItemId,
  onChangeSelectedSecondItemId: _productListPage.changeSelectedSecondItemId,
  routerPush: _reactRouterRedux.push,
  routerReplace: _reactRouterRedux.replace
})), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CustomProductList, _Component);

  function CustomProductList() {
    (0, _classCallCheck3.default)(this, CustomProductList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(CustomProductList).call(this));

    _this.state = {
      filter: '',
      isListPageMiddleFlipShown: true
    };
    return _this;
  }

  /*
   onOrderItemClick(val) {
   const {routerPush, location} = this.props;
   switch (val) {
   case 'isExperienceProduct':
   if (routerPush) {
   const query = {};
   query.isExperienceProduct = 1;
   routerPush({pathname: location.pathname, query: query});
   }
   break;
   case 'isExperienceGoods':
   if (routerPush) {
   const query = {};
   query.isExperienceGoods = 1;
   routerPush({pathname: location.pathname, query: query});
   }
   break;
   case 'addTime':
   if (routerPush) {
   const direction = location.query.direction === 'ASC' ? 'DESC' : 'ASC';
   routerPush({pathname: location.pathname, query: {...location.query, orderItem: val, direction}});
   }
   break;
   case 'salesVolume':
   if (routerPush) {
   const direction = location.query.direction === 'ASC' ? 'DESC' : 'ASC';
   routerPush({pathname: location.pathname, query: {...location.query, orderItem: val, direction}});
   }
   break;
   default:
   if (routerPush) {
   const query = {};
   routerPush({pathname: location.pathname, query: query});
   }
   }
   } */

  (0, _createClass3.default)(CustomProductList, [{
    key: 'onOrderItemClick',
    value: function onOrderItemClick(val) {
      var _props = this.props;
      var routerPush = _props.routerPush;
      var location = _props.location;

      switch (val) {
        case 'isExperienceProduct':
          if (routerPush) {
            if (!location.query.isExperienceProduct || location.query.isExperienceProduct === '0') {
              // const isExperienceProduct = location.query.isExperienceProduct === '1' ? '0' : '1';
              // const currentQuery = {...location.query, isExperienceProduct};
              var currentQuery = (0, _extends3.default)({}, location.query, { isExperienceProduct: '1' });
              if (currentQuery.isExperienceGoods) {
                delete currentQuery.isExperienceGoods;
              }
              if (currentQuery.isAppreciationGoods) {
                delete currentQuery.isAppreciationGoods;
              }
              if (currentQuery.isCommonProduct) {
                delete currentQuery.isCommonProduct;
              }
              if (currentQuery.page) {
                delete currentQuery.page;
              }
              routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, currentQuery) });
              // this.scrollToAnchor('onOrderItemClick');
            }
          }
          break;
        case 'isExperienceGoods':
          if (routerPush) {
            if (!location.query.isExperienceGoods || location.query.isExperienceGoods === '0') {
              // const isExperienceGoods = location.query.isExperienceGoods === '1' ? '0' : '1';
              // const currentQuery = {...location.query, isExperienceGoods};
              var _currentQuery = (0, _extends3.default)({}, location.query, { isExperienceGoods: '1' });
              if (_currentQuery.isExperienceProduct) {
                delete _currentQuery.isExperienceProduct;
              }
              if (_currentQuery.isAppreciationGoods) {
                delete _currentQuery.isAppreciationGoods;
              }
              if (_currentQuery.isCommonProduct) {
                delete _currentQuery.isCommonProduct;
              }
              if (_currentQuery.page) {
                delete _currentQuery.page;
              }
              routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, _currentQuery) });
              // this.scrollToAnchor('onOrderItemClick');
            }
          }
          break;
        case 'isAppreciationGoods':
          // console.log('isAppreciationGoods');
          if (routerPush) {
            if (!location.query.isAppreciationGoods || location.query.isAppreciationGoods === '0') {
              // const isAppreciationGoods = location.query.isAppreciationGoods === '1' ? '0' : '1';
              // const currentQuery = {...location.query, isAppreciationGoods};
              var _currentQuery2 = (0, _extends3.default)({}, location.query, { isAppreciationGoods: '1' });
              if (_currentQuery2.isExperienceProduct) {
                delete _currentQuery2.isExperienceProduct;
              }
              if (_currentQuery2.isExperienceGoods) {
                delete _currentQuery2.isExperienceGoods;
              }
              if (_currentQuery2.isCommonProduct) {
                delete _currentQuery2.isCommonProduct;
              }
              if (_currentQuery2.page) {
                delete _currentQuery2.page;
              }
              routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, _currentQuery2) });
              // this.scrollToAnchor('homePageOrderBar');
            }
          }
          break;
        case 'isCommonProduct':
          if (routerPush) {
            if (!location.query.isCommonProduct || location.query.isCommonProduct === '0') {
              var _currentQuery3 = (0, _extends3.default)({}, location.query, { isCommonProduct: '1' });
              if (_currentQuery3.isExperienceProduct) {
                delete _currentQuery3.isExperienceProduct;
              }
              if (_currentQuery3.isExperienceGoods) {
                delete _currentQuery3.isExperienceGoods;
              }
              if (_currentQuery3.isAppreciationGoods) {
                delete _currentQuery3.isAppreciationGoods;
              }
              if (_currentQuery3.page) {
                delete _currentQuery3.page;
              }
              routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, _currentQuery3) });
              // this.scrollToAnchor('homePageOrderBar');
            }
          }
          break;
        case 'salesVolume':
          if (routerPush) {
            var direction = location.query.direction === 'ASC' ? 'DESC' : 'ASC';
            routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, location.query, { orderItem: val, direction: direction }) });
            // this.scrollToAnchor('onOrderItemClick');
          }
          break;
        /* case 'addTime':
         if (!(location.query.orderItem === 'addTime' && location.query.direction === 'DESC')) {
         // const direction = 'DESC';
         const direction = location.query.direction === 'ASC' ? 'DESC' : 'ASC';
         routerPush({pathname: location.pathname, query: {...location.query, orderItem: val, direction}});
         // this.scrollToAnchor('onOrderItemClick');
         }
         break; */
        case 'addTime':
          if (routerPush) {
            /* let direction = 'DESC';
             if (location.query.orderItem === 'addTime' && location.query.direction === 'DESC') {
             direction = 'ASC';
             }
             routerPush({pathname: location.pathname, query: {...location.query, orderItem: val, direction}}); */
            routerPush({
              pathname: location.pathname,
              query: (0, _extends3.default)({}, location.query, {
                orderItem: val,
                direction: location.query.orderItem === 'addTime' && location.query.direction === 'DESC' ? 'ASC' : 'DESC'
              })
            });
          }
          break;
        case 'isMasterProduct':
          if (!(location.query.orderItem === 'addTime')) {
            var _direction = 'DESC';
            // const direction = location.query.direction === 'ASC' ? 'DESC' : 'ASC';
            routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, location.query, { orderItem: val, direction: _direction }) });
            // this.scrollToAnchor('onOrderItemClick');
          }
          break;
        case 'px':
          if (routerPush) {
            var query = (0, _extends3.default)({}, location.query);
            if (query.direction) {
              delete query.direction;
            }
            if (query.orderItem) {
              delete query.orderItem;
            }
            routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, query) });
          }
          break;
        default:
          if (routerPush) {
            var _query = {};
            if (location.query.type) {
              _query.type = location.query.type;
            }
            if (location.query.productType) {
              _query.productType = location.query.productType;
            }
            if (location.query.shop) {
              _query.shop = location.query.shop;
            }
            if (location.query.author) {
              _query.author = location.query.author;
            }
            /*  if (location.query.direction) {
             query.direction = location.query.direction;
             }
             if (location.query.orderItem) {
             query.orderItem = location.query.orderItem;
             } */
            routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, _query) });
            // this.scrollToAnchor('onOrderItemClick');
          }
      }
    }
  }, {
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      var _props2 = this.props;
      var routerPush = _props2.routerPush;
      var location = _props2.location;

      if (routerPush) {
        routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, location.query, { page: page }) });
        this.scrollToAnchor('onOrderItemClick');
      }
    }
  }, {
    key: 'onSearch',
    value: function onSearch(val) {
      var _props3 = this.props;
      var routerPush = _props3.routerPush;
      var location = _props3.location;

      if (routerPush) {
        var query = {};
        if (val) {
          query.findValue = val;
        }
        routerPush({ pathname: location.pathname, query: query });
      }
    }
  }, {
    key: 'onMiddleNavFilter',
    value: function onMiddleNavFilter(parentId, item) {
      // console.log(item);
      var _props4 = this.props;
      var routerPush = _props4.routerPush;
      var location = _props4.location;

      if (routerPush) {
        var query = {};
        if (parentId === 'M004257') {
          query.shop = item;
        } else if (parentId === 'M004313') {
          query.author = item;
        } else {
          if (parentId) {
            query.type = parentId;
          }
          if (item) {
            query.productType = item;
          }
        }
        routerPush({ pathname: location.pathname, query: query });
        // this.scrollToAnchor('onMiddleNavFilter');
      }
    }
  }, {
    key: 'onFilterDataLoad',
    value: function onFilterDataLoad(id) {
      var loadFilterData = this.props.loadFilterData;

      if (loadFilterData) {
        loadFilterData(id);
      }
    }
  }, {
    key: 'onFirstConstItemClick',
    value: function onFirstConstItemClick(id) {
      var _props5 = this.props;
      var routerPush = _props5.routerPush;
      var location = _props5.location;

      routerPush({ pathname: location.pathname, query: { type: id } });
    }
  }, {
    key: 'onNewFourConstBackClick',
    value: function onNewFourConstBackClick() {
      var _props6 = this.props;
      var routerPush = _props6.routerPush;
      var location = _props6.location;

      routerPush({ pathname: location.pathname });
      // this.scrollToAnchor('onMiddleNavFilter');
    }
  }, {
    key: 'onChangeSelectedFirstItem',
    value: function onChangeSelectedFirstItem(id) {
      var onChangeSelectedFirstItemId = this.props.onChangeSelectedFirstItemId;

      if (onChangeSelectedFirstItemId) {
        onChangeSelectedFirstItemId(id);
      }
    }
  }, {
    key: 'onChangeSelectedSecondItem',
    value: function onChangeSelectedSecondItem(id) {
      var onChangeSelectedSecondItemId = this.props.onChangeSelectedSecondItemId;

      if (onChangeSelectedSecondItemId) {
        onChangeSelectedSecondItemId(id);
      }
    }
  }, {
    key: 'changeShownOfBelow',
    value: function changeShownOfBelow(shown) {
      this.setState({
        isListPageMiddleFlipShown: shown
      });
    }
  }, {
    key: 'scrollToAnchor',
    value: function scrollToAnchor(anchorName) {
      if (anchorName) {
        var anchorElement = document.getElementById(anchorName);
        if (anchorElement) {
          anchorElement.scrollIntoView();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props7 = this.props;
      var data = _props7.data;
      var filterData = _props7.filterData;
      var selectedFirstItemId = _props7.selectedFirstItemId;
      var selectedSecondItemId = _props7.selectedSecondItemId;
      var location = _props7.location;
      var isListPageMiddleFlipShown = this.state.isListPageMiddleFlipShown;

      var realFilterData = [];
      if (filterData && filterData.filterData instanceof Array) {
        realFilterData = filterData.filterData;
      }
      /* const middleFilterFirstLevel = [{
       id: 'M0043950000000000000000004',
       img: 'http://tupian.goeasy.cn:9999/yipinwang/third/shx_bg1.jpg'
       }, {
       id: 'M0043950000000000000000005',
       img: 'http://tupian.goeasy.cn:9999/yipinwang/third/shx_bg2.jpg'
       }, {
       id: 'M0043950000000000000000003',
       img: 'http://tupian.goeasy.cn:9999/yipinwang/third/shx_bg3.jpg'
       }, {
       id: 'M0043950000000000000000002',
       img: 'http://tupian.goeasy.cn:9999/yipinwang/third/shx_bg4.jpg'
       }, {
       id: 'M004257',
       img: 'http://tupian.goeasy.cn:9999/yipinwang/third/shx_bg5.jpg',
       loadData: '1'
       }, {
       id: 'M004313',
       img: 'http://tupian.goeasy.cn:9999/yipinwang/third/shx_bg6.jpg',
       loadData: '1'
       }]; */
      /* const middleFilterFirstLevel = [{
       id: 'M0043950000000000000000004',
       img: 'http://tupian.goeasy.cn:9999/yipinwang/third/fenleibg1.jpg'
       }, {
       id: 'M0043950000000000000000002',
       img: 'http://tupian.goeasy.cn:9999/yipinwang/third/fenleibg2.jpg'
       }, {
       id: 'M0043950000000000000000003',
       img: 'http://tupian.goeasy.cn:9999/yipinwang/third/fenleibg3.jpg'
       }, {
       id: 'M0043950000000000000000005',
       img: 'http://tupian.goeasy.cn:9999/yipinwang/third/fenleibg4.jpg'
       }, {
       id: 'M004313',
       img: 'http://tupian.goeasy.cn:9999/yipinwang/third/fenleibg5.jpg',
       loadData: '1'
       }, {
       id: 'M004257',
       img: 'http://tupian.goeasy.cn:9999/yipinwang/third/fenleibg6.jpg',
       loadData: '1'
       }]; */
      /* const middleFilterSecondLevel = [{
       'id': 'M0040390000000000000000001',
       'name': '雕塑艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/shx_bg8.jpg'
       }, {
       'id': 'M0040390000000000000000003',
       'name': '漆器艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/shx_bg9.jpg'
       }, {
       'id': 'M0040390000000000000000009',
       'name': '民族工艺',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/shx_bg10.jpg'
       }, {
       'id': 'M0040390000000000000000005',
       'name': '纤维编织',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/shx_bg11.jpg'
       }, {
       'id': 'M0040390000000000000000010',
       'name': '陶瓷艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/shx_bg12.jpg'
       }, {
       'id': 'M0040390000000000000000002',
       'name': '金属艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/shx_bg13.jpg'
       }, {
       'id': 'M0040390000000000000000004',
       'name': '花画艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg87.jpg'
       }, {
       'id': 'M0040390000000000000000008',
       'name': '珠宝首饰',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg88.jpg'
       }, {
       'id': 'M0040390000000000000000007',
       'name': '地毯挂毯',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg89.jpg'
       }, {
       'id': 'M0040390000000000000000006',
       'name': '抽纱刺绣',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg90.jpg'
       }]; */
      /* const middleFilterSecondLevel = [{
       'id': 'M0040390000000000000000001',
       'name': '雕塑艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/fenleibg12.jpg'
       }, {
       'id': 'M0040390000000000000000003',
       'name': '漆器艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/fenleibg7.jpg'
       }, {
       'id': 'M0040390000000000000000009',
       'name': '民族工艺',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/fenleibg9.jpg'
       }, {
       'id': 'M0040390000000000000000005',
       'name': '纤维编织',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/fenleibg11.jpg'
       }, {
       'id': 'M0040390000000000000000010',
       'name': '陶瓷艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/fenleibg8.jpg'
       }, {
       'id': 'M0040390000000000000000002',
       'name': '金属艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/fenleibg10.jpg'
       }, {
       'id': 'M0040390000000000000000004',
       'name': '花画艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/fenleibg13.jpg'
       }, {
       'id': 'M0040390000000000000000008',
       'name': '珠宝首饰',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/fenleibg14.jpg'
       }, {
       'id': 'M0040390000000000000000007',
       'name': '地毯挂毯',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/fenleibg15.jpg'
       }, {
       'id': 'M0040390000000000000000006',
       'name': '抽纱刺绣',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/fenleibg16.jpg'
       }]; */
      /* const middleFilterSecondLevel = [{
       'id': 'M0040390000000000000000003',
       'name': '漆器艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/newthird/fenleibg7.jpg'
       }, {
       'id': 'M0040390000000000000000010',
       'name': '陶瓷艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/newthird/fenleibg8.jpg'
       }, {
       'id': 'M0040390000000000000000002',
       'name': '金属艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/newthird/fenleibg10.jpg'
       }, {
       'id': 'M0040390000000000000000005',
       'name': '纤维编织',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/newthird/fenleibg11.jpg'
       }, {
       'id': 'M0040390000000000000000009',
       'name': '民族工艺',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/newthird/fenleibg9.jpg'
       }, {
       'id': 'M0040390000000000000000004',
       'name': '花画艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/newthird/fenleibg13.jpg'
       }, {
       'id': 'M0040390000000000000000008',
       'name': '珠宝首饰',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/newthird/fenleibg14.jpg'
       }, {
       'id': 'M0040390000000000000000007',
       'name': '地毯挂毯',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/newthird/fenleibg15.jpg'
       }, {
       'id': 'M0040390000000000000000001',
       'name': '雕塑艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/newthird/fenleibg12.jpg'
       }, {
       'id': 'M0040390000000000000000006',
       'name': '抽纱刺绣',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/newthird/fenleibg16.jpg'
       }, {
       'id': 'M0040390000000000000000011',
       'name': '书画艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/newthird/fenleibg27.jpg'
       }];
       */
      /* const middleFilterFourthLevel = [{
       parentId: 'M0040390000000000000000001',
       topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/diaosugongyi.jpg',
       bottomItems: [{
       id: '1',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/dsyp/1.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg28.png'
       }, {
       id: '2',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/dsyp/2.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg30.png'
       }, {
       id: '3',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/dsyp/3.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg32.png'
       }, {
       id: '4',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/dsyp/4.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg34.png'
       }]
       }, {
       parentId: 'M0040390000000000000000003',
       topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/qiqiyipin.jpg',
       bottomItems: [{
       id: '5',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/qqyp/1.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg36.png'
       }, {
       id: '6',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/qqyp/2.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg38.png'
       }, {
       id: '7',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/qqyp/3.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg40.png'
       }, {
       id: '8',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/qqyp/4.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg42.png'
       }]
       }, {
       parentId: 'M0040390000000000000000009',
       topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/minzugongyi.jpg',
       bottomItems: [{
       id: '9',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/mzgy/1.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg44.png'
       }, {
       id: '10',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/mzgy/2.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg46.png'
       }, {
       id: '11',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/mzgy/3.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg48.png'
       }, {
       id: '12',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/mzgy/4.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg50.png'
       }]
       }, {
       parentId: 'M0040390000000000000000005',
       topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/xianweibianzhi.jpg',
       bottomItems: [{
       id: '13',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/xwbz/1.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg52.png'
       }, {
       id: '14',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/xwbz/2.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg54.png'
       }, {
       id: '15',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/xwbz/3.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg56.png'
       }, {
       id: '16',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/xwbz/4.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg58.png'
       }]
       }, {
       parentId: 'M0040390000000000000000010',
       topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/taociyipin.jpg',
       bottomItems: [{
       id: '17',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/tcyp/1.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg60.png'
       }, {
       id: '18',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/tcyp/2.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg62.png'
       }, {
       id: '19',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/tcyp/3.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg64.png'
       }, {
       id: '20',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/tcyp/4.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg66.png'
       }]
       }, {
       parentId: 'M0040390000000000000000002',
       topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/jinshuyipin.jpg',
       bottomItems: [{
       id: '21',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/jsyp/1.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg68.png'
       }, {
       id: '22',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/jsyp/2.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg70.png'
       }, {
       id: '23',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/jsyp/3.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg72.png'
       }, {
       id: '24',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/jsyp/4.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg74.png'
       }]
       }, {
       parentId: 'M0040390000000000000000004',
       topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/huahuagongyi.jpg',
       bottomItems: [{
       id: '25',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/hhgy/1.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg76.png'
       }, {
       id: '26',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/hhgy/2.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg78.png'
       }, {
       id: '27',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/hhgy/3.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg80.png'
       }, {
       id: '28',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/hhgy/4.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg82.png'
       }]
       }, {
       parentId: 'M0040390000000000000000008',
       topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/zhubaoshoushi.jpg',
       bottomItems: [{
       id: '29',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/zbss/1.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg11.png'
       }, {
       id: '30',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/zbss/2.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg13.png'
       }, {
       id: '31',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/zbss/3.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg15.png'
       }, {
       id: '32',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/zbss/4.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg17.png'
       }]
       }, {
       parentId: 'M0040390000000000000000007',
       topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/ditanguatan.jpg',
       bottomItems: [{
       id: '33',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/dtgt/1.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg11.png'
       }, {
       id: '34',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/dtgt/2.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg13.png'
       }, {
       id: '35',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/dtgt/3.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg15.png'
       }, {
       id: '36',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/dtgt/4.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg17.png'
       }]
       }, {
       parentId: 'M0040390000000000000000006',
       topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/choushacixiu.jpg',
       bottomItems: [{
       id: '37',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/cscx/1.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg11.png'
       }, {
       id: '38',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/cscx/2.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg13.png'
       }, {
       id: '39',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/cscx/3.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg15.png'
       }, {
       id: '40',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/cscx/4.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg17.png'
       }]
       }, {
       parentId: 'M004313',
       bottomItems: [{
       id: '41',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img20.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img20_1.png'
       }, {
       id: '42',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img21.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img21_1.png'
       }, {
       id: '43',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img22.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img22_1.png'
       }, {
       id: '44',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img23.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img23_1.png'
       }]
       }, {
       parentId: 'M004257',
       bottomItems: [{
       id: '45',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img20.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img20_1.png'
       }, {
       id: '46',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img21.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img21_1.png'
       }, {
       id: '47',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img22.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img22_1.png'
       }, {
       id: '48',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img23.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img23_1.png'
       }]
       }, {
       parentId: 'M0040390000000000000000011',
       topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/shuhuayipin.jpg',
       bottomItems: [{
       id: '33',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/shyp/1.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/shyp/5.png'
       }, {
       id: '34',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/shyp/2.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/shyp/6.png'
       }, {
       id: '35',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/shyp/3.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/shyp/7.png'
       }, {
       id: '36',
       front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/shyp/4.png',
       back: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/shyp/8.png'
       }]
       }];
       */
      var carouselDiv = '';
      var productDiv = '';
      var totalPageNumber = 1;
      if (data) {
        var products = data.products;
        var productsError = data.productsError;
        var productsRecordCount = data.productsRecordCount;
        var productsPagesize = data.productsPagesize;
        var customProductsCarousel = data.customProductsCarousel;
        var customProductsCarouselError = data.customProductsCarouselError;

        if (customProductsCarouselError) {
          carouselDiv = '错误：' + customProductsCarouselError;
        } else if (customProductsCarousel instanceof Array) {
          carouselDiv = _react2.default.createElement(_components.GoeasyCarousel, { page: 'productList', images: customProductsCarousel });
        }
        if (productsError) {
          productDiv = _react2.default.createElement(
            'li',
            { style: { width: '100%', fontSize: 16, textAlign: 'center' } },
            productsError
          );
        } else {
          productDiv = _react2.default.createElement(
            'ul',
            { style: { width: '100%' } },
            products instanceof Array ? products.map(function (product, index) {
              return _react2.default.createElement(_components.ProductInfo, { key: product.id, isCustom: true, index: index, product: product });
            }) : _react2.default.createElement(
              'li',
              { style: { width: '100%', fontSize: 16, textAlign: 'center' } },
              '未搜索到相关艺品'
            )
          );
        }
        totalPageNumber = parseInt(productsRecordCount / productsPagesize, 10);
        if (productsRecordCount % productsPagesize > 0) {
          ++totalPageNumber;
        }
      }
      /*   const orderArray = [
       {id: '', text: '全部艺品'},
       {id: 'isExperienceProduct', text: '爆款'},
       {id: 'isExperienceGoods', text: '体验品'},
       // {id: 'salesVolume', text: '销量'}
       {id: 'isAppreciationGoods', text: '鉴赏品'},
       {id: 'addTime', text: '新品'},
       {id: 'price', text: '价格'}
       ];
       */
      var orderObject = {
        texts: [{ id: '', text: '全部艺品' }, { id: 'isCommonProduct', text: '定制艺品' }, { id: 'isExperienceProduct', text: '爆款' }, { id: 'isExperienceGoods', text: '体验品' }, { id: 'isAppreciationGoods', text: '鉴赏品' }],
        orderTexts: [{ id: 'px', text: '综合排序' }, { id: 'addTime', text: '上架时间' }, { id: 'isMasterProduct', text: '大师艺品' }]
      };
      var middleImages = ['http://tupian.goeasy.cn:9999/yipinwang//third/gdz_bg1.png', 'http://tupian.goeasy.cn:9999/yipinwang//third/gdz_bg2.png'];
      return _react2.default.createElement(
        'div',
        null,
        carouselDiv,
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.HomePageSearchBar, { placeholderTexts: '请输入作者\\店铺\\艺品\\关键字', onSearch: this.onSearch.bind(this) }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement('a', { id: 'onMiddleNavFilter' }),
        _react2.default.createElement(_components.NewListPageFilterBar, { changeShownOfBelow: this.changeShownOfBelow.bind(this),
          data: realFilterData,
          selectedFirstItemId: selectedFirstItemId,
          selectedSecondItemId: selectedSecondItemId,
          onChangeSelectedFirstItemId: this.onChangeSelectedFirstItem.bind(this),
          onChangeSelectedSecondItemId: this.onChangeSelectedSecondItem.bind(this),
          firstItemClick: this.onFilterDataLoad.bind(this),
          firstConstItemClick: this.onFirstConstItemClick.bind(this),
          onFourthConstBackBtnClick: this.onNewFourConstBackClick.bind(this),
          secondItemClick: this.onMiddleNavFilter.bind(this) }),
        _react2.default.createElement('div', { className: 'clear' }),
        isListPageMiddleFlipShown ? _react2.default.createElement(_components.ListPageMiddleFlip, { data: middleImages }) : '',
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement('a', { id: 'onOrderItemClick' }),
        _react2.default.createElement(_components.ProductPageOrderBar, { items: orderObject,
          isOrder: true,
          location: location,
          onItemClick: this.onOrderItemClick.bind(this) }),
        _react2.default.createElement('div', { className: 'clear' }),
        productDiv,
        totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { totalPageNumber: totalPageNumber, onPageItemClick: this.onPageItemClick.bind(this) }) : '',
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return CustomProductList;
}(_react.Component), _class2.propTypes = {
  location: _react.PropTypes.object,
  productsError: _react.PropTypes.string,
  currentPage: _react.PropTypes.string,
  selectedFirstItemId: _react.PropTypes.string,
  selectedSecondItemId: _react.PropTypes.string,
  dispatch: _react.PropTypes.func,
  data: _react.PropTypes.object,
  load: _react.PropTypes.func,
  routerPush: _react.PropTypes.func,
  routerReplace: _react.PropTypes.func,
  changeCurrentPage: _react.PropTypes.func,
  loadFilterData: _react.PropTypes.func,
  onChangeSelectedFirstItemId: _react.PropTypes.func,
  onChangeSelectedSecondItemId: _react.PropTypes.func,
  filterData: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = CustomProductList;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/CustomProductList/CustomProductList.js
 ** module id = 1458
 ** module chunks = 0
 **/